import { useContext, useEffect, useState } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { Flexbox } from '@hiiretail/synergy-ui';
import { DeleteButton } from '../../../common/components/Breadcrumbs/buttons/DeleteButton/DeleteButton';
import { useBreadcrumbsActions } from '../../../common/components/Breadcrumbs/context/useBreadcrumbsActions';
import { useHistory } from "react-router-dom";
import { useDeleteGroup } from './useDeleteGroup';
import { BreadcrumbsActionsContextType } from '../../../common/components/Breadcrumbs/context/BreadcrumbsActionsContext';
import { useQueryClient } from "react-query";

type UseDeleteGroupModalFacade = () => {
  deleteGroup: () => void,
  isDeleting: boolean,
  isDeleteGroupModalOpen: boolean,
  closeDeleteGroupModal: () => void,
};

export const useDeleteGroupModalFacade: UseDeleteGroupModalFacade = () => {
  const { updateActions } = useBreadcrumbsActions();
  const { showNotification } = useContext(NotificationsContext);
  const history = useHistory();
  const queryClient = useQueryClient();
  const [isDeleteGroupModalOpen, setIsDeleteGroupModalOpen] = useState(false);

  const openDeleteGroupModal = () => setIsDeleteGroupModalOpen(true);

  const closeDeleteGroupModal = () => setIsDeleteGroupModalOpen(false);

  const onSuccess = () => {
    queryClient.invalidateQueries([ 'groups' ]).then();
    showNotification('Group successfully deleted');
    closeDeleteGroupModal();
    history.push('/groups');
  };

  const onError = () => showNotification('An error occurred while removing group');

  const {
    mutate: deleteGroup,
    isLoading: isDeleting,
  } = useDeleteGroup({
    onSuccess,
    onError,
  });

  useEffect(() => {
    updateActions( (prevActions: BreadcrumbsActionsContextType['actions']) => (
      <>
        {prevActions}
        <Flexbox item>
          <DeleteButton
            title="Delete"
            onClick={openDeleteGroupModal}
            permission="iam.group.delete"
            disabled={isDeleting}
          />
        </Flexbox>
      </>
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    deleteGroup,
    isDeleting,
    isDeleteGroupModalOpen,
    closeDeleteGroupModal,
  };
};
